<template>
    <div>
        <h2 class="text-md-center">Work Experience</h2>
        <Job v-for="job in jobs" :job="job.job" :tech-job="job.techJob" v-bind:key="job.job" :information="job.information"></Job>
    </div>
</template>

<script>
    import Job from "@/components/Job";

    export default {
        name: "Experience",
        components: {
            Job
        },
        data () {
            return {
                jobs: [
                    {
                        job: "Web Application Development",
                        information: {
                            year: 'December 2019 – Present',
                            points: [
                                'Serving non-technical businesses',
                                'Collaborating with a professional developer',
                                'Developing single-page applications with aws',
                                'Exploring S3 static website hosting, API Gateway, Lambda, and Textract'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Food Safety Net Services",
                        information: {
                            year: 'May 2019 – Present',
                            points: [
                                'Introduced modern IT concepts such as cloud and machine learning to CEO',
                                'Commercial pathogen testing on variate of food and non-food samples',
                                'Customer service and relations',
                                'Quality assurance of microbial testing',
                                'Deep understanding of the needs and wants of costumers',
                                'Practiced multiple lab techniques in identification of possible pathogenic bacteria',
                                'VIDAS and PCR-BAX identification'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Ohio Wesleyan University",
                        information: {
                            year: 'Aug 2019 – Dec 2019',
                            points: [
                                'Student for Data Mining and Machine Learning',
                                'Created and utilized machine learning algorithms such as naive bayes and 1R creating a rich understanding of techniques utilized in real world practices'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Ohio Wesleyan University",
                        information: {
                            year: 'May 2019 – Dec 2019',
                            points: [
                                'Utilized spices to optimize viral production of T2 bacteriophages.',
                                'Utilized spices to decrease bacteriophage replication in E. coli, acting as a possible substitute for DON, which may be as a medical treatment as an antiviral or anticancer drug',
                                'Bacteriophage replication and culture upkeep',
                                'E. coli growth curves using spectrophotometry',
                                'Currently in process of publishing in STM Journals as an author. Title: \'Cinnamon Extract and Cinnamaldehyde Inhibit the Replication of T2 Bacteriophage in E. coli: Potential for Use in Antiviral and Anticancer Therapy\''
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Ecological Society of America",
                        information: {
                            year: 'May 2019',
                            points: [
                                'Presented topics about invasive honeysuckle to the scientific community'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Ohio Wesleyan University",
                        information: {
                            year: 'May 2018 – Aug 2019',
                            points: [
                                'Measured soil respiration with infrared gas analyzer (LI-COR LI-6400)',
                                'Data mining and Analysis with R',
                                'Sample collection and analysis of different plant species',
                                'Presented at ESA',
                                'Currently in the process of being published'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Ohio Wesleyan University",
                        information: {
                            year: 'Jan 2018– May 2018',
                            points: [
                                'Plant Responses to Global Changes in Alaska',
                                'Vital understanding of the current global changes due to human advancement',
                                'Laboratory experiences in Alaska',
                                'Measuring plant gas exchange',
                                'Coring trees',
                                'Statistical Analyses'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "3Bar Biologics Inc.",
                        information: {
                            year: 'May 2017 – Aug 2017',
                            points: [
                                'Performed multiple scientific tests on commercial product',
                                'Optimization of commercial biological product',
                                'Chemical testing',
                                'Contamination sourcing',
                                'Conduct of recent scientific literature to further develop product'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Shudog Services LLC",
                        information: {
                            year: 'Dec 2010 - May 2016',
                            points: [
                                'Co-Founder/CEO of landscaping division',
                                'Hired, trained, and managed 5 employees',
                                'Expanded to a loyal clientele of 25+',
                                'History of approximately 50 clients'
                            ]
                        },
                        techJob: false
                    }
                ]

            }
        }
    }
</script>

<style scoped>

</style>
